import React from "react";
export var ControlType;
(function (ControlType) {
    ControlType[ControlType["previous"] = 0] = "previous";
    ControlType[ControlType["next"] = 1] = "next";
})(ControlType || (ControlType = {}));
